import React, { ReactElement, useEffect, useState } from 'react';
import { Loader } from 'idsk-react-components';
import useNotifikaciaHistoriaList from './hook/useNotifikaciaHistoriaList';
import NotifikaciaHistoriaListTable from './component/NotifikaciaHistoriaListTable';
import NotifikaciaHistoriaActions from './component/NotifikaciaHistoriaActions';
import { NotifikaciaTypEnum } from '../../../model/notifikacia/NotifikaciaTyp';
import Dropdown from '../../Dropdown';
import './notifikaciaHistoriaList.scss';
import LegislativnyMaterialDetail
  from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { useLegMaterialHistoria } from '../LegislativnyMaterialHistoria';
import { getNotifikaciaHistoriaAdminActions } from './function/getNotifikaciaHistoriaAdminActions';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
}

const NotifikaciaHistoriaList = ({
  materialDetail,
}: Props): ReactElement => {
  const [actions, setActions] = useState<Array<NotifikaciaTypEnum>>([]);
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  const {
    notifikaciaHistoriaPage,
    notifikaciaHistoriaStatus,
    reloadNotifikaciaHistoria,
  } = useNotifikaciaHistoriaList(materialDetail.uuid);

  const {
    legMaterialHistoriaList,
    legMaterialHistoriaStatus,
  } = useLegMaterialHistoria(materialDetail?.uuid);

  const [sendNotificationLoading, setSendNotificationLoading] = useState<boolean>(false);

  useEffect(() => {
    if (legMaterialHistoriaStatus?.finished) {
      setActions(getNotifikaciaHistoriaAdminActions(materialDetail, legMaterialHistoriaList?.historiaRecords));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legMaterialHistoriaStatus]);

  return (
    <div className="notifikacia-historia-list">
      <Loader loading={notifikaciaHistoriaStatus.loading || legMaterialHistoriaStatus.loading}>
        <>
          {(actions.length > 0) && (
            <div className="dropdown__button">
              <Dropdown
                title="Opakované odoslanie notifikácií"
                loading={sendNotificationLoading}
                isDropdownOpened={isDropdownOpened}
                setIsDropdownOpened={setIsDropdownOpened}
              >
                <NotifikaciaHistoriaActions
                  notifikaciaActions={actions}
                  materialUuid={materialDetail.uuid}
                  reloadNotifikaciaHistoria={reloadNotifikaciaHistoria}
                  setSendNotificationLoading={setSendNotificationLoading}
                  setIsDropdownOpened={setIsDropdownOpened}
                />
              </Dropdown>
            </div>
          )}
          <NotifikaciaHistoriaListTable notifikaciaHistoriaPage={notifikaciaHistoriaPage} />
        </>
      </Loader>
    </div>
  );
};

export default NotifikaciaHistoriaList;
